import { request } from './client';

const startGame = (mode) => request('/wordpro/start/', {
  method: 'POST',
  body: JSON.stringify({ mode }),
});

const submitGuess = (sessionId, guess) => request(`/wordpro/sessions/${sessionId}/guess/`, {
  method: 'POST',
  body: JSON.stringify({ guess }),
});

const startTimer = (sessionId) => request(`/wordpro/sessions/${sessionId}/start-timer/`, {
  method: 'POST',
});

const chooseEasyLeaderboard = (sessionId, useForLeaderboard) => request(
  `/wordpro/sessions/${sessionId}/easy-leaderboard-choice/`,
  { method: 'POST', body: JSON.stringify({ use_for_leaderboard: useForLeaderboard }) },
);

const getLeaderboard = (date, page = 1, pageSize = 10) => request(
  `/wordpro/leaderboard/?date=${date}&page=${page}&page_size=${pageSize}`,
);
const getPossibleWords = (entryId, sequence) => request(
  `/wordpro/leaderboard/${entryId}/guesses/${sequence}/possible-words/`,
);
const getHistory = () => request('/wordpro/history/');
const getStatistics = () => request('/wordpro/statistics/');
const getDailyStatus = () => request('/wordpro/status/');

export { chooseEasyLeaderboard, getDailyStatus, getHistory, getLeaderboard, getPossibleWords, getStatistics, startGame, startTimer, submitGuess };
